/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface ExplorerConfigDto
 */
export interface ExplorerConfigDto {
  /**
   * Chest size.
   *
   * @type {string}
   * @memberof ExplorerConfigDto
   * @example S
   */
  chest_size: ExplorerConfigDtoChestSizeEnum;

  /**
   * Shoe size.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 30
   */
  shoe_size: ExplorerConfigDtoShoeSizeEnum;

  /**
   * Left femur length.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 25
   */
  femur_len_l: number;

  /**
   * Right femur length.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 25
   */
  femur_len_r: number;

  /**
   * Left tibia length.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 30
   */
  tibia_len_l: number;

  /**
   * Right tibia length.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 30
   */
  tibia_len_r: number;

  /**
   * Walker length in meters.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 2
   */
  walker_len: number;

  /**
   * Hip width in centimeters.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 30
   */
  hip_width: number;

  /**
   * Hip flexion in degrees.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 10
   */
  flexos_hip: number;

  /**
   * Knee flexion in degrees.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 15
   */
  flexos_knee: number;

  /**
   * Abduction value.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 5
   */
  abd: number;

  /**
   * Whether the ankle is locked.
   *
   * @type {boolean}
   * @memberof ExplorerConfigDto
   * @example true
   */
  ankle_lock: boolean;

  /**
   * Corset size/type.
   *
   * @type {string}
   * @memberof ExplorerConfigDto
   * @example Small Flat
   */
  corset: ExplorerConfigDtoCorsetEnum;

  /**
   * Sitting position angle in degrees.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 0
   */
  sit_position?: number;

  /**
   * Standing position angle in degrees.
   *
   * @type {number}
   * @memberof ExplorerConfigDto
   * @example 0
   */
  stand_position?: number;
}

/**
 * @export
 * @enum {string}
 */
export enum ExplorerConfigDtoChestSizeEnum {
  S = 'S',
  L = 'L',
}
/**
 * @export
 * @enum {string}
 */
export enum ExplorerConfigDtoShoeSizeEnum {
  NUMBER_25 = 25,
  NUMBER_30 = 30,
  NUMBER_38 = 38,
}
/**
 * @export
 * @enum {string}
 */
export enum ExplorerConfigDtoCorsetEnum {
  SmallFlat = 'Small Flat',
  SmallCurve = 'Small Curve',
  BigFlat = 'Big Flat',
  BigCurve = 'Big Curve',
}
